import * as React from 'react';
import { IgcCarouselComponent as Component } from 'igniteui-webcomponents';
import type { IgcCarouselComponentEventMap } from 'igniteui-webcomponents';
import { type EventName, createComponent } from '../react-props.js';

/**
 * The `igc-carousel` presents a set of `igc-carousel-slide`s by sequentially displaying a subset of one or more slides.
 * @slot Default - slot for the carousel. Any projected `igc-carousel-slide` components should be projected here.
 * @slot previous-button - Renders content inside the previous button.
 * @slot next-button - Renders content inside the next button.
 * @fires igcSlideChanged - Emitted when the current active slide is changed either by user interaction or by the interval callback.
 * @fires igcPlaying - Emitted when the carousel enters playing state by a user interaction.
 * @fires igcPaused - Emitted when the carousel enters paused state by a user interaction.
 * @csspart navigation - The wrapper container of each carousel navigation button.
 * @csspart previous - The wrapper container of the carousel previous navigation button.
 * @csspart next - The wrapper container of the carousel next navigation button.
 * @csspart dot - The carousel dot indicator container.
 * @csspart active - The carousel active dot indicator container.
 * @csspart label - The label container of the carousel indicators.
 * @csspart start - The wrapping container of all carousel indicators when indicators-orientation is set to start.
 * @class
 */
export const IgrCarousel = /* @__PURE__ */ createComponent({
  tagName: 'igc-carousel',
  displayName: 'IgrCarousel',
  elementClass: Component,
  react: React,
  events: {
    onSlideChanged: 'igcSlideChanged' as EventName<
      IgcCarouselComponentEventMap['igcSlideChanged']
    >,
    onPlaying: 'igcPlaying' as EventName<
      IgcCarouselComponentEventMap['igcPlaying']
    >,
    onPaused: 'igcPaused' as EventName<
      IgcCarouselComponentEventMap['igcPaused']
    >,
  },
});

export type IgrCarousel = Component;

/** @deprecated Module register is no longer needed and can be removed */
export const IgrCarouselModule = Component;
